import SVGContainer from "../SVGContainer";
import styled from "styled-components";

const StyledSVGContainer = styled(SVGContainer)`
	position:absolute;
	width:100$;
`
const index = () => {
	return (
		<StyledSVGContainer>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="16"
				height="16"
				viewBox="0 0 16 16"
			>
				<path
					fill="#A7AAB0"
					fillRule="evenodd"
					d="M8,2 C10.2966621,2 12.1944871,3.08475139 13.6975758,4.85215186 C14.5752413,5.88415118 15.1407955,6.91102607 15.4281873,7.62788663 L15.5772688,7.99975071 L15.4283594,8.37168374 C15.1413108,9.08864891 14.5761586,10.1156284 13.6986838,11.1477294 C12.1959964,12.9152162 10.2978234,14 8,14 C5.70217657,14 3.80400361,12.9152162 2.30131617,11.1477294 C1.42384136,10.1156284 0.858689218,9.08864891 0.571640588,8.37168374 L0.422731169,7.99975071 L0.571812711,7.62788663 C0.85920449,6.91102607 1.42475868,5.88415118 2.30242422,4.85215186 C3.80551288,3.08475139 5.70333787,2 8,2 Z M13.240615,7.70117491 C12.9484834,7.17075241 12.5923777,6.63975259 12.1740368,6.14784814 C11.019464,4.79024861 9.63688584,4 8,4 C6.36311416,4 4.98053601,4.79024861 3.82596323,6.14784814 C3.40762228,6.63975259 3.05151663,7.17075241 2.75938498,7.70117491 C2.69901325,7.81079165 2.64627812,7.91104308 2.60115646,8.00022317 C2.64621723,8.0893632 2.69888128,8.18956552 2.75917298,8.29912599 C3.05103264,8.82948565 3.4068974,9.36042394 3.82505712,9.8522706 C4.97919188,11.2097838 6.3619256,12 8,12 C9.6380744,12 11.0208081,11.2097838 12.1749429,9.8522706 C12.5931026,9.36042394 12.9489674,8.82948565 13.240827,8.29912599 C13.3011187,8.18956552 13.3537828,8.0893632 13.3988435,8.00022317 C13.3537219,7.91104308 13.3009867,7.81079165 13.240615,7.70117491 Z M8,11 C6.34314575,11 5,9.65685425 5,8 C5,6.34314575 6.34314575,5 8,5 C9.65685425,5 11,6.34314575 11,8 C11,9.65685425 9.65685425,11 8,11 Z M8,9 C8.55228475,9 9,8.55228475 9,8 C9,7.44771525 8.55228475,7 8,7 C7.44771525,7 7,7.44771525 7,8 C7,8.55228475 7.44771525,9 8,9 Z"
				/>
			</svg>
		</StyledSVGContainer>
	)
}

export default index
